import { useMemo } from 'react';
import PreSubmitErrorMessagesBanner from './PreSubmitErrorMessagesBanner';
import { useSelector } from 'react-redux';
import { getShowAllErrors } from '../state/errorMessagesSlice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useGetErrorMessagesAndTranslations } from '../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FormSubmitErrorMsgs({
  isUngatedToDescriptiveErrors,
  submitEnabled,
  showRequiredFieldsAlert,
  setShowRequiredFieldsAlert,
  submitObject
}) {
  var _useGetErrorMessagesA, _useGetErrorMessagesA2;
  const showAllErrors = useSelector(getShowAllErrors);
  const preSubmitErrorMessages = Array.from((_useGetErrorMessagesA = (_useGetErrorMessagesA2 = useGetErrorMessagesAndTranslations()) === null || _useGetErrorMessagesA2 === void 0 ? void 0 : _useGetErrorMessagesA2.values()) !== null && _useGetErrorMessagesA !== void 0 ? _useGetErrorMessagesA : []);
  const {
    errorMessage: postSubmitErrorMessage,
    resetError
  } = submitObject;
  const shouldShowPreSubmitErrorMessagesBanner = !submitEnabled && showAllErrors && showRequiredFieldsAlert;
  const preSubmitErrorMessagesBannerComponent = useMemo(() => {
    if (!isUngatedToDescriptiveErrors && shouldShowPreSubmitErrorMessagesBanner) {
      return /*#__PURE__*/_jsx(Alert, {
        marginBlockStart: "500",
        type: "danger",
        "data-test-id": "confirm-card-payment-error-alert",
        closeable: true,
        onClose: () => {
          setShowRequiredFieldsAlert(false);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.inputError.emptyErrorBanner"
        })
      });
    } else if (isUngatedToDescriptiveErrors && shouldShowPreSubmitErrorMessagesBanner && preSubmitErrorMessages.length > 0) {
      return /*#__PURE__*/_jsx(PreSubmitErrorMessagesBanner, {
        preSubmitErrorMessages: preSubmitErrorMessages,
        setShowRequiredFieldsAlert: setShowRequiredFieldsAlert
      });
    }
    return null;
  }, [preSubmitErrorMessages, isUngatedToDescriptiveErrors, setShowRequiredFieldsAlert, shouldShowPreSubmitErrorMessagesBanner]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "confirm-card-payment-error-alert",
    children: [preSubmitErrorMessagesBannerComponent, postSubmitErrorMessage && !shouldShowPreSubmitErrorMessagesBanner && /*#__PURE__*/_jsx(Alert, {
      "data-test-id": "post-submit-confirm-card-payment-error-alert",
      marginBlockStart: "500",
      type: "danger",
      closeable: true,
      onClose: resetError,
      children: postSubmitErrorMessage
    })]
  });
}
export default FormSubmitErrorMsgs;